import CrudPage from "@/components/admin/CrudPage";

const FIELDS = [
  { key: "customer_display_name", label: "Customer display name" },
  { key: "rating", label: "Rating (1-5)", type: "number" },
  { key: "review_excerpt", label: "Review excerpt", type: "textarea", rows: 3, span: "full" },
  { key: "source", label: "Source", type: "select", options: ["Yelp", "Google", "Facebook", "Customer text", "Other"] },
  { key: "review_date", label: "Review date" },
  { key: "active", label: "Active", type: "checkbox" },
  { key: "sort_order", label: "Sort order", type: "number" },
];

const BLANK = {
  customer_display_name: "", rating: 5, review_excerpt: "",
  source: "Customer text", review_date: "", active: true, sort_order: 99,
};

export default function AdminReviews() {
  return (
    <CrudPage
      resource="reviews"
      title="Reviews"
      description="Only reviews marked Active will show on the public website. Active reviews appear on the homepage and Reviews page. Only add real reviews from Yelp, Google, Facebook, text messages, or customers who gave permission. Do not invent testimonials."
      fields={FIELDS}
      blank={BLANK}
      testIdPrefix="reviews"
    />
  );
}
